import { type ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onAuthStateChanged } from "@firebase/auth";

import { setSentryUser } from "@/apps/admin/configurations/sentry";
import { auth } from "@/common/platform/firebase";
import genFiveApi from "@/state/api";

import { selectUser, selectUserLoaded, setUser } from "../authenticationSlice";
import AuthenticationMethods from "../SignInMethods/AuthenticationMethods";
const Authenticated = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const userLoaded = useSelector(selectUserLoaded);
  useEffect(() => {
    return onAuthStateChanged(auth, (user) => {
      setSentryUser(user);
      if (user) {
        const {
          displayName,
          email,
          emailVerified,
          photoURL,
          uid,
          isAnonymous,
        } = user;
        dispatch(
          setUser({
            displayName,
            email,
            emailVerified,
            photoURL,
            uid,
            isAnonymous,
          })
        );
      } else {
        dispatch(setUser(null));
        // Cached responses belong to the account that just signed out
        dispatch(genFiveApi.util.resetApiState());
      }
    });
  }, [dispatch]);

  if (!user && userLoaded) {
    return <AuthenticationMethods />;
  } else if (user && userLoaded) {
    return children;
  }
};

export default Authenticated;
